import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="px-4 md:px-6 max-w-screen-2xl mx-auto py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <span className="text-xl font-heading font-bold text-background-50">韩漫大全</span>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed max-w-md">
              韩漫大全致力于为广大韩漫爱好者提供无遮挡下拉式免费阅读体验。加载迅速、无干扰，让您专注享受韩漫画情节。每天更新最新最热的韩国漫画，永久免费。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">全部漫画</Link>
              <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">恋爱漫画</Link>
              <Link to="/category/action" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">动作漫画</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">奇幻漫画</Link>
              <Link to="/category/drama" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">剧情漫画</Link>
              <Link to="/category/comedy" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">喜剧漫画</Link>
              <Link to="/category/horror" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">恐怖漫画</Link>
              <Link to="/category/historical" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">古风漫画</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫大全. 本站所有漫画均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}